<template>
    <PDA_Allocated-components>
        <div class="p-2 m-3">

            <div id="listloader" v-if="Loader">
                <div class="listloader"></div>
            </div>

            <!-- Allocate PDA -->
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row>
                    <b-col md="4">
                        <b-from-group>
                            <b-row>
                                <b-col md="3" class="pr-0">
                                    <strong>User Name</strong>
                                </b-col>
                                <b-col md="9" class="pl-0">
                                    <v-select v-model="customer.username" :options="userList" placeholder="-- Select User --" name="User Name" v-validate="'required'"
                                    :class="{input: true,'is-invalid': errors.has('form-1.User Name'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning" v-show="errors.has('User Name')"></i>
                                        </span>
                                        <span style="width:240px" v-show="errors.has('form-1.User Name')" class="help text-danger">{{ errors.first("form-1.User Name") }}</span>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-from-group>
                    </b-col>

                    <b-col md="3">
                        <b-from-group>
                            <b-row>
                                <b-col md="4" class="pr-0">
                                    <strong>PDA Name</strong>
                                </b-col>
                                <b-col md="8" class="pl-0 pr-0">
                                    <v-select v-model="customer.pdaid" :options="pdaidList" placeholder="-- Select PDA Name --" name="PDA Name" v-validate="'required'"
                                    :class="{input: true,'is-invalid': errors.has('form-1.PDA Name'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning" v-show="errors.has('PDA Name')"></i>
                                        </span>
                                        <span style="width:240px" v-show="errors.has('form-1.PDA Name')" class="help text-danger">{{ errors.first("form-1.PDA Name") }}</span>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-from-group>
                    </b-col>

                    <b-col md="3">
                        <b-from-group>
                            <b-row>
                                <b-col md="3" class="pr-0">
                                    <strong>Shift</strong>
                                </b-col>
                                <b-col md="9" class="pl-0">
                                    <v-select v-model="customer.shift" :options="shiftList" placeholder="-- Select Shift --" name="shift" v-validate="'required'"
                                    :class="{input: true,'is-invalid': errors.has('form-1.shift'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i class="fa fa-warning" v-show="errors.has('shift')"></i>
                                        </span>
                                        <span style="width:240px" v-show="errors.has('form-1.shift')" class="help text-danger">{{ errors.first("form-1.shift") }}</span>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-from-group>
                    </b-col>
                    <b-col md="2" class="p-0">
                        <b-button variant="primary" type="submit" :disabled="isReadOnly">Allocate</b-button> &nbsp;
                        <b-button variant="danger" @click="clear()">Clear</b-button>
                    </b-col>
                </b-row>
            </b-form>

            <!-- Table -->
            <br><br>
            <b-row>
                <b-col md="6">
                    <span style="font-size: 15px;">Allocated PDA (today)</span>
                </b-col>
                <b-col md="6">
                    <div class="float-right">
                        <b>Total Records : <span style="color: red;">{{totalRows}}</span></b>
                    </div>
                </b-col>
            </b-row>

            <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" :outlined="outlined" :busy="isBusy">
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>  
                <template slot="user_name" slot-scope="row">
                    <div>
                        {{ row.item.userfirstname + ' ' +  row.item.userlastname}}
                    </div>
                </template>
            </b-table>

            <!-- paginatio -->
            <b-col md="12" class="my-1" >
                <paginate 
                v-model="pageNum"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>   
        </div>
    </PDA_Allocated-components>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    name:'PDA_Allocated',
    data() {
        return {
            Loader:false,
            // List 
            userList:[],
            pdaidList:[],
            shiftList:['1','2','3'],


            customer:{},

            // Table
            isBusy:false,
            totalRows:0,
            items:[],
            fields:[
                {key:'pda_id', label:'PDA ID',thClass: 'text-center'},
                {key:'pda_name', label:'PDA Name',thClass: 'text-center'},
                {key:'user_name', label:'User Name',thClass: 'text-center'},
                {key:'allocated_date', label:'Date',thClass: 'text-center'},
                {key:'allocated_time', label:'PDA Allocated Time',thClass: 'text-center'},
                {key:'hanover_time', label:'PDA Handover Time',thClass: 'text-center'},
                {key:'pda_condition', label:'Condition',thClass: 'text-center'},
                {key:'pda_severity', label:'Severity',thClass: 'text-center'},
                {key:'issue_name', label:'Issues',thClass: 'text-center'},
                {key:'shift', label:'Shift',thClass: 'text-center'},
                {key:'session', label:'Active Status',thClass: 'text-center'},
            ],
            currentPage:1,
            perPage:20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
        this.userNameList();
        this.pdaList();
        this.allocatePDAList(this.pageNum);
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        
        userNameList(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.userList = [];
            var List = []
            var obj = {};

            if (userInfo.user_type==1) {
                obj = {
                    user_type:`${userInfo.user_type}`
                }
            } else {
                obj = {
                    hub_id:userInfo.hub_id,
                    user_type:`${userInfo.user_type}`
                }
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getUserNameListing`,obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let user = {
                            key : element.sysusermasterid,
                            value : element.hub_id,
                            label : element.userfirstname + ' ' + element.userlastname +' - '+element.hub_id,
                        }
                        this.userList.push(user)
                    });
                } else {
                    this.userList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        pdaList(){
            this.pdaidList=[];
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var List = [];
            const Obj={
                status:'allocated',
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addedPDAListing`,Obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let PDA = {
                            key : element.pda_id,
                            value : element.hub_id,
                            label : element.pda_name+' - '+element.hub_id,
                        }
                        this.pdaidList.push(PDA)
                    });

                } else {
                    this.pdaidList=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.allocatetouserPDA();
                }
            });
        },

        allocatetouserPDA(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            console.log("this.customer.username.value--------->",this.customer.username.value,this.customer.pdaid.value);
            // console.log("-------->>>>>>>",userInfo.user_type===1,userInfo.user_type)
            if(this.customer.username.value != this.customer.pdaid.value){
                this.Loader = false;
                this.$fire({
                        text: "Can Not Allocate .PDA And User Hub need to be same.",
                        type: "error",
                        timer: 30000,
                    });
                    return false
            }else{
                const Obj ={
                pda_id : this.customer.pdaid.key,
                sysusermasterid : `${this.customer.username.key}`,
                shift : `${this.customer.shift}`,
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                hub_id : userInfo.user_type===1?this.customer.username.value:userInfo.hub_id,
                session : 'open',
                // pda_allocated_by : `${userInfo.sysusermasterid==null?'':userInfo.sysusermasterid}`
            }
            
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/allocatePDAToUser`,Obj)
            .then(result=>{
                this.Loader = false;
                if (result.body.returnmsg==='Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.userNameList();
                    this.pdaList();
                    this.allocatePDAList(this.pageNum);
                    this.customer={};
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
            }
            
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.allocatePDAList(pageNum);
        },

        allocatePDAList(page_Num){
            this.isBusy=true;
            this.items=[];
            this.totalRows=0;

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={
                status:'allocated',
                page_no:`${page_Num}`,
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/allocatePDAToUserList`,Obj)
            .then(result=>{
                this.isBusy=false;
                if (result.body.returnmsg==='Successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows =  result.body.totalrecord;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.items=[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clear(){
            this.customer={};
            this.userNameList();
            this.pdaList();
            this.allocatePDAList(this.pageNum);
        }
    },
}
</script>